import { ChannelComponent } from './components/channel/channel.component';
import { SettingsComponent } from './components/settings/settings.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER, NO_ERRORS_SCHEMA } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgxJsonViewerModule } from 'ngx-json-viewer';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './components/app.component';
import { LoginComponent } from './components/login/login.component';
import { NotifierOptions, NotifierModule } from 'angular-notifier';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { AuthInterceptor } from './services/auth.interceptor.service';
import { CookieService } from 'ngx-cookie-service';
import { WrapperComponent } from './components/wrapper/wrapper.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { UsersComponent } from './components/users/users.component';
import { HeaderComponent } from './components/header/header.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { AppConfigService } from './services/appconfig.service';
import { SocketService } from './services/socket.service';
import { BrokersComponent } from './components/brokers/brokers.component';
import { ReportAlertsComponent } from './components/report-alerts/report-alerts.component' 
import { DataCollectionComponent } from './components/data-collection/data-collection.component';
import { LogsComponent } from './components/logs/logs.component';
import { StrategyComponent } from './components/strategy/strategy.component' 
import { InstrumentComponent } from './components/instrument/instrument.component' 
import { WrapperComponent as StrategyWrapperComponent } from './components/thread/wrapper/wrapper.component';
import { TradeboardListComponent } from './components/tradeboard-list/tradeboard-list.component';
import { TradeboardComponent } from './components/tradeboard/tradeboard.component';
import { TradeboardContentComponent } from './components/tradeboard-content/tradeboard-content.component';
import { DataService } from './services/data.service';
import { LssV1Component } from './components/thread/lss-v1/lss-v1.component';
import { OrbV1Component } from './components/thread/orb-v1/orb-v1.component';
import { ThreadComponent } from './components/thread/thread.component' 
import { DetailsModalComponent } from './components/thread/details-modal/details-modal.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { OrderPositionsComponent } from './components/order-positions/order-positions.component';

const customNotifierOptions: NotifierOptions = {
  position: {
    horizontal: { position: 'right', distance: 12 },
    vertical: { position: 'top', distance: 12, gap: 10 }
  },
  theme: 'material',
  behaviour: { autoHide: 3000, onClick: 'hide', onMouseover: 'pauseAutoHide', showDismissButton: true, stacking: 1 },
  animations: {
    enabled: true,
    show: { preset: 'slide', speed: 300, easing: 'ease' },
    hide: { preset: 'fade', speed: 300, easing: 'ease', offset: 50 },
    shift: { speed: 300, easing: 'ease' },
    overlap: 150
  }
};

export function init_app(appConfigService: AppConfigService) {
  return () => appConfigService.load();
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    WrapperComponent,
    SidebarComponent,
    UsersComponent,
    HeaderComponent,
    PaginationComponent,
    BrokersComponent,
    DataCollectionComponent,
    ChannelComponent,
    SettingsComponent,
    LogsComponent,
    StrategyComponent,
    InstrumentComponent,
    ReportAlertsComponent,
    TradeboardListComponent,
    TradeboardComponent,
    TradeboardContentComponent,
    ThreadComponent,
    LssV1Component,
    OrbV1Component,
    StrategyWrapperComponent,
    DetailsModalComponent,
    DashboardComponent,
    OrderPositionsComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgxJsonViewerModule,
    LoadingBarModule,
    LoadingBarHttpClientModule,
    NotifierModule.withConfig(customNotifierOptions)
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: init_app,
      deps: [AppConfigService],
      multi: true
    },
    AppConfigService,
    CookieService,
    SocketService,
    DataService
  ],
  schemas:[NO_ERRORS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
